<i *ngFor="let icon of icons" [ngClass]="icon.classes" class="fa" aria-hidden="true"></i>